import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { BaseCell } from "@similarweb/pro-logic-components";
import { IconButton } from "@similarweb/ui-components";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: center;
`;

export const StyledInCRMButton = styled(IconButton)`
    height: 28px !important;
    padding: 0 10px !important;

    & ${SWReactIcons} {
        width: 12px;
        height: 12px;
        margin-right: 3px;
        margin-bottom: 2px;
        & svg {
            width: 12px;
            height: 12px;
        }
    }
    & > div {
        font-size: 10.5px;
    }
`;
